import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { ToastContainer as OriginalToastContainer, toast as showToast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

var toast = function toast(_ref) {
  var icon = _ref.icon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      text = _ref.text,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-center' : _ref$position,
      _ref$autoClose = _ref.autoClose,
      autoClose = _ref$autoClose === void 0 ? 3000 : _ref$autoClose,
      _ref$hideProgressBar = _ref.hideProgressBar,
      hideProgressBar = _ref$hideProgressBar === void 0 ? true : _ref$hideProgressBar,
      _ref$closeOnClick = _ref.closeOnClick,
      closeOnClick = _ref$closeOnClick === void 0 ? false : _ref$closeOnClick,
      _ref$pauseOnHover = _ref.pauseOnHover,
      pauseOnHover = _ref$pauseOnHover === void 0 ? false : _ref$pauseOnHover,
      _ref$draggable = _ref.draggable,
      draggable = _ref$draggable === void 0 ? false : _ref$draggable;
  showToast(text, {
    icon: icon,
    type: type,
    position: position,
    autoClose: autoClose,
    hideProgressBar: hideProgressBar,
    closeOnClick: closeOnClick,
    pauseOnHover: pauseOnHover,
    draggable: draggable,
    closeButton: false
  });
};

var ToastContainer = styled(OriginalToastContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .Toastify__toast {\n    border-radius: 5px;\n    font-family: 'Ubuntu';\n  }\n  .Toastify__toast-theme--colored {\n    background: #4B4B4B;\n  }\n\n  .Toastify__toast-theme--colored.Toastify__toast--default {\n    color: #fff;\n  }\n\n  @media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    border-radius: 0;\n  }\n}\n"])));
export { ToastContainer, toast };